// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules

// App
import { apiEndpoints } from "../../config";

import { TextField } from "@mui/material";

import PostEdit from "../../partials/posts/postEdit";
import DatePickerField from "../../partials/datePicker";
import WebformSelector from "./webformSelector";

import { Row, Col } from "react-bootstrap";

export default function EventEdit() {
  const [post, setPost] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [website, setWebsite] = useState("");
  const [address, setAddress] = useState("");

  useEffect(() => {
    if (!post) return;
    if (post.field_start_date) {
      setStartDate(post.field_start_date);
    }
    if (post.field_end_date) {
      setEndDate(post.field_end_date);
    }
    if (post.field_email) {
      setEmail(post.field_email);
    }
    if (post.field_contact_number) {
      setContact(post.field_contact_number);
    }
    if (post.field_website) {
      setWebsite(post.field_website);
    }
    if (post.field_address) {
      setAddress(post.field_address);
    }
  }, [post]);

  const extraFields = useMemo(() => {
    const _startDate = startDate ? { field_start_date: startDate } : {};
    const _endDate = endDate ? { field_end_date: endDate } : {};
    const emailData = email ? { field_email: email } : {};
    const phoneData = contact ? { field_contact_number: contact } : {};
    const linkData = website ? { field_website: website } : {};
    const locationData = address ? { field_address: address } : {};

    return {
      ..._startDate,
      ..._endDate,
      ...emailData,
      ...phoneData,
      ...linkData,
      ...locationData,
    };
  }, [startDate, endDate, email, contact, website, address]);

  return (
    <PostEdit
      entityType={"event"}
      apiEndpoint={apiEndpoints.events}
      screenClassName={"events"}
      categoryTitle={"Event category"}
      categoryName={"field_event_category"}
      targetVid={"event_categories"}
      returnRoute={"/events-creator"}
      backBtnText={"Event Library"}
      previewRoute={"/events/preview"}
      logCustomEventType={"Event"}
      extraFields={extraFields}
      featuredImageEnabled={true}
      featuredImageFiles={{ aspectRatio: 1 }}
      editorProps={{
        title: true,
        subtitle: true,
        summary: true,
        body: true,
        list: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        map: true,
      }}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      <Row className="my-3">
        <Col xs="6">
          <DatePickerField
            label="Start Date & Time"
            value={startDate}
            onChange={setStartDate}
          />
        </Col>
        <Col xs="6">
          <DatePickerField
            label="End Date & Time"
            value={endDate}
            onChange={setEndDate}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs="3">
          <TextField
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="small"
          />
        </Col>
        <Col xs="3">
          <TextField
            label="Phone"
            variant="outlined"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            size="small"
          />
        </Col>
        <Col xs="3">
          <TextField
            label="Link"
            variant="outlined"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            size="small"
          />
        </Col>
        <Col xs="3">
          <TextField
            label="Location"
            variant="outlined"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            size="small"
          />
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <WebformSelector />
        </Col>
      </Row>
    </PostEdit>
  );
}
